export const fathom = {
    name: 'Fathom',
    key: 'fathom',
    assets: {
        icon: '/images/competitors/fathom.svg',
        comparisonArticle: '/blog/posthog-vs-fathom',
    },
    available: true,
    products: {
        web_analytics: {
            available: true,
            features: {
                advertising_analytics: false,
                bounce_rate: true,
                bounce_rate_tracking: false,
                breakdown_by_device_and_browser: false,
                breakdown_by_geoip: false,
                conversions: true,
                custom_channel_types: false,
                entry_exit_paths: false,
                first_party_cookies: false,
                hipaa_compliance: false,
                integration_with_feature_flags: false,
                integration_with_session_replay: false,
                integration_with_surveys: false,
                migration: true,
                movement_maps: false,
                open_source: false,
                outbound_clicks: false,
                pageviews: true,
                pre_configured_dashboards: false,
                real_time_reporting: false,
                revenue_tracking: false,
                script_size: '<2 kB',
                search_tools: false,
                session_and_duration_tracking: false,
                sessions: false,
                snippet_install: true,
                traffic_breakdown: true,
                utm_tracking: true,
                visitor_and_view_tracking: false,
                web_vitals: false,
                web_vitals_reporting: false,
            },
        },
        product_analytics: {
            available: 'Limited',
            features: {
                advertising_analytics: false,
                autocapture: 'Pageviews',
                cohorts: false,
                custom_events: 'Events only',
                custom_properties: true,
                monetization_analytics: false,
                predictive_insights: false,
                real_time_view: false,
                toolbar: false,
                user_profiles: false,
                trends: {
                    available: false,
                    features: {},
                },
                funnels: {
                    available: false,
                    features: {
                        conversion_funnels: true,
                        correlation_analysis: false,
                    },
                },
                retention: {
                    available: false,
                    features: {},
                },
                user_paths: {
                    available: false,
                    features: {},
                },
                lifecycle: {
                    available: false,
                    features: {},
                },
                stickiness: {
                    available: false,
                    features: {},
                },
                group_analytics: {
                    available: false,
                    features: {},
                },
                insights: {
                    available: false,
                    features: {
                        formula_mode: false,
                        ready_made_insight_types: false,
                        sampling: false,
                        sql_editor: false,
                    },
                },
            },
        },
        session_replay: {
            available: false,
        },
        feature_flags: {
            available: false,
        },
        experiments: {
            available: false,
        },
        surveys: {
            available: false,
        },
        heatmaps: {
            available: false,
            features: {
                clickmaps: false,
                heatmaps: false,
                scrollmaps: false,
            },
        },
    },
    platform: {
        analytics_integration: {
            built_in_analytics: false,
        },
        deployment: {
            eu_hosting: true,
            open_source: false,
            reverse_proxy: false,
            self_host: false,
        },
        developer: {
            api: true,
            collaboration: 'Share web analytics with or without a password',
            mobile_sdks: false,
            server_side_sdks: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            csv_exports: true,
            datadog: false,
            exports: false,
            email_reports: true,
            hubspot: false,
            sentry: false,
            slack: false,
            stripe: false,
            warehouse_import: false,
            wordpress: true,
            zapier: false,
            zendesk: false,
        },
        pricing: {
            free_tier: false,
            self_serve: 'Trial only',
            transparent_pricing: false,
            usage_based_pricing: true,
        },
        security: {
            bot_blocking: true,
            cookieless_tracking: true,
            data_retention: "Forever (as long as you're a customer)",
            gdpr_ready: true,
            hipaa_ready: false,
            saml_sso: false,
            soc2_certified: false,
            two_factor_auth: true,
        },
    },
    pricing: {
        model: 'Monthly subscription',
    },
}
